module.exports = __webpack_public_path__ + "img/sv44.8248ba87.svg";